import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import type { ScenarioKpi } from "../../../services/api";
import { deltaTone, formatAmount, formatDelta } from "../scenarioFormat";

/** Today, the scenario and the change for each headline measure. */
export function KpiStrip({ kpis }: { kpis: ScenarioKpi[] }) {
  return (
    <section className="scenario-kpi-strip" aria-label="Scenario results">
      {kpis.map((item) => {
        const tone = deltaTone(item.delta, item.higherIsBetter);
        const Icon =
          item.delta == null || item.delta === 0
            ? Minus
            : item.delta > 0
              ? ArrowUpRight
              : ArrowDownRight;
        return (
          <div
            key={item.id}
            className={`panel scenario-kpi${item.emphasis ? " emphasis" : ""}`}
            data-testid={`kpi-${item.id}`}
          >
            <span className="scenario-kpi-label">{item.label}</span>
            <strong>{formatAmount(item.scenario, item.unit)}</strong>
            <span className="scenario-kpi-baseline">
              Today {formatAmount(item.baseline, item.unit)}
            </span>
            <span className={`scenario-kpi-delta ${tone}`}>
              <Icon size={13} aria-hidden="true" />
              {formatDelta(item.delta, item.unit)}
            </span>
          </div>
        );
      })}
    </section>
  );
}
